<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Réponses - {{customer.company}} - {{questionnaire.reason.label}}</h1>
                <div class="pageOptions">
                    <btn text="Ajouter" ico="add" @click="add()"
                         v-if="$store.getters.hasPerm('questionnaire:add/edit')"></btn>
                </div>
            </div>
            <search-bar @search="search" :value="filter"></search-bar>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                <tr>
                    <th>
                        Date
                        <table-order name="label" @change="changeOrder"></table-order>
                    </th>
                    <th>
                        Options
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(response, key) in visibles">
                    <td>{{response.createAt|formatDateHour}}</td>
                    <td class="tableOptions">
                        <svg class="option" @click="edit(response.id)"
                             v-if="$store.getters.hasPerm('response:add/edit')">
                            <use xlink:href="#icon-eye"></use>
                        </svg>
                    </td>
                </tr>
                <tr v-if="visibles.length <= 0">
                    <td colspan="5" style="text-align: center">Il n'y a aucune réponse à ce questionnaire</td>
                </tr>
                </tbody>
            </table>
            <pagination :current="currentPage" :limit="limit" :array="filters" @change="pageChange"
                        @limitChange="limitChange"></pagination>
        </div>
    </div>
</template>

<script>
    import SearchBar from "@/components/SearchBar";
    import Pagination from "@/components/Pagination";
    import Loader from "@/components/Loader";
    import TableOrder from "@/components/TableOrder";
    import axios from 'axios';
    import tools from '../config.ts';
    import Btn from "@/components/Btn";

    export default {
        name: "Responses",
        components: {Btn, Pagination, SearchBar, Loader, TableOrder},
        data() {
            return {
                currentPage: 0,
                limit: 100,
                filter: "",
                order: {
                    order: 'asc',
                    name: 'label',
                },

                responses: [],
                questionnaire: {reason:{label:""}},
                customer: {},

                questionnaireId: 0,
                customerId: 0,

                locals: ["currentPage", "filter", "order"],
                cookies: ["limit"],
            }
        },
        methods: {
            load() {

                axios.get(tools.api("customer/" + this.customerId), tools.headerGET())
                    .then((response) => {
                        this.customer = response.data;
                    })

                axios.get(tools.api("questionnaire/" + this.questionnaireId ), tools.headerGET())
                    .then((response) => {
                        this.questionnaire = response.data;
                    })

                axios.get(tools.api("customer/" + this.customerId + "/questionnaire/" + this.questionnaireId + "/responses"), tools.headerGET())
                    .then((response) => {
                        this.responses = response.data;

                        tools.loader(false);
                        tools.saveLocals("responses", this);
                    })
                    .catch((e) => {
                        tools.loader(false)
                    })
            },
            edit(responseId){
                this.$router.push("/customer/"+this.customerId+"/questionnaire/"+this.questionnaireId+"/response/"+responseId)
            },
            limitChange(limit) {
                this.limit = limit;
                this.currentPage = 0;

                tools.saveCookies("responses", this);
            },
            pageChange(page) {
                this.currentPage = page;

                tools.saveLocals("responses", this);
            },
            search(filter) {
                this.filter = filter;

                tools.saveLocals("responses", this);
            },
            changeOrder(data) {
                this.order = {
                    order: data.order,
                    name: data.name
                }
                tools.saveLocals("responses", this);
            },
        },
        computed: {
            filters() {

                let responses = this.responses;

                if (this.filter) {
                    console.log(this.filter)
                    let reg = new RegExp(this.filter, "i");
                    responses = responses.filter((questionnaire) => reg.exec(questionnaire.createAt))
                }

                tools.sortArray(responses, this.order);

                return responses;
            },
            visibles() {
                return this.filters.slice(this.currentPage * this.limit, (this.currentPage * this.limit) + parseInt(this.limit));
            }
        },
        mounted() {
            if (!this.$store.getters.hasPerm('responses:list')) {
                return this.$router.back();
            }


            this.customerId = this.$route.params.customer_id;
            this.questionnaireId = this.$route.params.questionnaire_id;

            tools.setLocals("responses", this);
            tools.setCookies("responses", this);

            tools.$emit("orderChange", this.order);

            tools.loader(true);

            this.$store.commit("onEditMode", false);

            this.load();
        }
    }
</script>